import CampoTexto from "../../../Campos/CampoTexto";
import CampoCep from "../../../Campos/CampoCep";
import { Grid } from "@mui/material";
import { Skeleton } from "@mui/material";
import Seletor from "../../../Seletor";
import { useEffect, useState } from "react";

export default function EnderecoNacional({
  enderecoDefaultValue,
  isLoading,
  setData,
  cepSelected,
  onChangeCep,
  validationErrors = {},
  hasValidationError,
}) {
  const [seletorKey, setSeletorKey] = useState(0);

  const handleChange = (e) => {
    let newEndereco = {
      ...enderecoDefaultValue,
      [e.target.name]: e.target.value,
    };

    if (e.target.name === "cep") {
      newEndereco.idPais = 0;
      onChangeCep(true);
    }

    setData(newEndereco);
  };

  const handleChangeUf = (idUf) => {
    let newEndereco = {
      ...enderecoDefaultValue,
      idUf: idUf,
    };

    setData(newEndereco);
  };

  const handleChangeEnderecoByCEP = (e) => {
    e = e.data;

    let newEndereco = {
      ...enderecoDefaultValue,
      cidade: e.cidade,
      bairro: e.bairro,
      logradouro: e.logradouro,
      idUf: e.idUf,
      idPais: e.idPais,
      numero: enderecoDefaultValue.numero,
    };

    setSeletorKey((prev) => prev + 1);
    setData(newEndereco);
  };

  return (
    <Grid
      container
      xs={12}
      rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 1, md: 2 }}
    >
      {isLoading ? (
        <>
          {Array.from({ length: 7 }, (_, index) => (
            <Grid item xs={index === 0 ? 12 : 6} key={index}>
              <Skeleton animation="wave" height={60} />
            </Grid>
          ))}
        </>
      ) : (
        <>
          <Grid item xs={12}>
            <CampoCep
              handlerChange={handleChange}
              name="cep"
              recarregar={cepSelected}
              size="medium"
              fullWidth={true}
              value={
                enderecoDefaultValue.cep == null ? "" : enderecoDefaultValue.cep
              }
              label={"Cep"}
              enable={true}
              setEndereco={handleChangeEnderecoByCEP}
              idTipoEndereco={1}
              idCliente={enderecoDefaultValue.idCliente}
              isEnderecoCliente={enderecoDefaultValue.idCliente > 0}
              // Adicione as props de erro
              error={hasValidationError && hasValidationError('cep')}
              helperText={validationErrors.cep || ''}
              required={true}
            />
          </Grid>

          <Grid item xs={6}>
            <CampoTexto
              handlerChange={handleChange}
              name="logradouro"
              fullWidth={true}
              required={true}
              size="medium"
              value={enderecoDefaultValue.logradouro}
              label="Logradouro"
              enable={true}
              defaultValue="Logradouro"
              // Adicione as props de erro
              error={hasValidationError && hasValidationError('logradouro')}
              helperText={validationErrors.logradouro || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <CampoTexto
              handlerChange={handleChange}
              name="numero"
              required={true}
              fullWidth={true}
              size="medium"
              value={enderecoDefaultValue.numero}
              label="Número"
              enable={true}
              defaultValue="Número"
              // Adicione as props de erro (se número for obrigatório)
              error={hasValidationError && hasValidationError('numero')}
              helperText={validationErrors.numero || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <CampoTexto
              fullWidth={true}
              handlerChange={handleChange}
              name="complemento"
              size="medium"
              value={enderecoDefaultValue.complemento}
              label="Complemento"
              enable={true}
              defaultValue="Complemento"
              // Complemento geralmente não é obrigatório
            />
          </Grid>
          <Grid item xs={6}>
            <CampoTexto
              fullWidth={true}
              handlerChange={handleChange}
              name="bairro"
              required={true}
              size="medium"
              value={enderecoDefaultValue.bairro}
              label="Bairro"
              enable={true}
              defaultValue="Bairro"
              // Adicione as props de erro
              error={hasValidationError && hasValidationError('bairro')}
              helperText={validationErrors.bairro || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <CampoTexto
              fullWidth={true}
              handlerChange={handleChange}
              name="cidade"
              required={true}
              size="medium"
              value={enderecoDefaultValue.cidade}
              label="Cidade"
              defaultValue="Cidade"
              enable={true}
              // Adicione as props de erro
              error={hasValidationError && hasValidationError('cidade')}
              helperText={validationErrors.cidade || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <Seletor
              key={seletorKey}
              setSelect={handleChangeUf}
              list={enderecoDefaultValue.ufs || []}
              size="medium"
              required={true}
              label="UF"
              value={enderecoDefaultValue.idUf}
              isLoading={isLoading && enderecoDefaultValue.ufs?.length === 0}
              fullWidth={true}
              // Adicione as props de erro (se UF for obrigatória)
              error={hasValidationError && hasValidationError('idUf')}
              helperText={validationErrors.idUf || ''}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}